import axios from 'axios';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';
import { IVisitor } from '../../types/interfaces';
import store from '../store';

export const getNotaires = async (projectId: number): Promise<any> => {
  return new Promise((resolve) => {
  axios
    .get('/api/notaires', {...tokenConfig(store.getState), params: {projectId}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => {
      resolve(false);
      console.log("err getNotaires", err)
    });
  });
};